
import React  from 'react';  

export const appointmentsConfig = [

  {
    auth: ['user'],
    routes: [
      {
        exact: true,
        path: '/appointments',
        component: React.lazy(() => import('./AppointmentsList')),
      },
    ],
  },
 
  // {
  //   auth: ['user'],
  //   routes: [
  //     {
  //       path: '/appointments',
  //       component: React.lazy(() => import('./AppointmentTabs')),
  //     },
  //   ],
  // },
  // {
  //   auth: ['user'],
  //   routes: [
  //     {
  //       path: '/appointment-success',
  //       component: React.lazy(() => import('./BookNewAppointment/AppAppointmentSuccess')),
  //     },
  //   ],
  // }
];